import React, {useEffect, useRef, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import {useGetUserQuery, useCreatePaymentMutation, useGetPaymentsQuery} from "../services/endpoints/user.api";
// import logo from "../assets/media/logo_pay.png";
// import { QRCodeCanvas } from 'qrcode.react';  // Importa il componente QRCode
import Logo from './base/LogoComponent';
import Header from './base/HeaderComponent'
import Footer from "./base/FooterComponent";
import './Login.css'
import {useLoginMutation, useRegisterMutation} from "../services/endpoints/user.api";
import {updateAccessToken} from "../services/userAuthSlice";
const Registration = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const navigate = useNavigate(); // Usa useNavigate per ottenere la funzione di navigazione
    const [registration, { isLoading }] = useRegisterMutation(); // Hook RTK
    const [errorMessage, setErrorMessage] = useState(null); // <-- errore locale
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordValid, setPasswordValid] = useState(false);

    const validatePassword = (pwd) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        return regex.test(pwd);
    };

    const usernameGenerator = function (nome, cognome) {
        const nomeTrim = nome.trim().toLowerCase().replace(/\s+/g, "");
        const cognomeTrim = cognome.trim().toLowerCase().replace(/\s+/g, "");

        const parteNome = nomeTrim.slice(0, 3);
        const parteCognome = cognomeTrim.slice(0, 3);

        const numeroCasuale = Math.floor(1000 + Math.random() * 9000); // da 1000 a 9999

        return `${parteNome}${parteCognome}${numeroCasuale}`;
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        if(password !== password2) {
            setErrorMessage("Le password non corrispondono");
            return;
        }

        const username = usernameGenerator(name, surname)

        try {
            const result = await registration({ name, surname, email, password, username  }).unwrap();
            if(result)
            navigate("/success");
        } catch (err) {
                if(err.data.errorType === 403) {
                    setErrorMessage("Utente già registrato");
                } else {
                    setErrorMessage(err.data)
                }
                console.error("Registration error", err);
        }
    };
    return (
        <div>
            <Header/>
            <main className="container form-signin w-50 pt-5 m-sm-auto text-center">
                <form onSubmit={handleSubmit}>
                    {errorMessage && (
                        <div className="alert alert-danger" role="alert">
                            {errorMessage}
                        </div>
                    )}
                    <div className="form-floating mb-3">
                        <input
                            type="text"
                            className="form-control"
                            id="name"
                            placeholder="name@example.com"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                        <label htmlFor="floatingInput">Nome</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            type="text"
                            className="form-control"
                            id="surname"
                            placeholder="name@example.com"
                            value={surname}
                            onChange={(e) => setSurname(e.target.value)}
                            required
                        />
                        <label htmlFor="floatingInput">Cognome</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="name@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <label htmlFor="floatingInput">Email</label>
                    </div>

                    <div className="form-floating mb-3 position-relative">
                        <input
                            type={passwordVisible ? "text" : "password"}
                            className={`form-control ${password ? (passwordValid ? "is-valid" : "is-invalid") : ""}`}
                            id="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => {
                                const pwd = e.target.value;
                                setPassword(pwd);
                                setPasswordValid(validatePassword(pwd));
                            }}
                            required
                        />
                        <label htmlFor="password">Password</label>

                        {/* Toggle visibilità */}
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary top-50 position-absolute end-0 translate-middle-y me-5 border-0"
                            onClick={() => setPasswordVisible(!passwordVisible)}
                            tabIndex={-1}
                        >
                            {passwordVisible ? "🙈" : "👁️"}
                        </button>

                        {/* Mostra feedback solo se l'utente ha digitato qualcosa */}
                        {password && (
                            <>
                                {!passwordValid ? (
                                    <div className="invalid-feedback text-start d-block">
                                        Min. 8 caratteri, 1 maiuscola, 1 minuscola, 1 numero, 1 simbolo.
                                    </div>
                                ) : (
                                    <div className="valid-feedback text-start d-block">Password valida</div>
                                )}
                            </>
                        )}
                    </div>

                    <div className="valid-feedback text-start">Password valida</div>


                    <div className="form-floating mb-3">
                        <input
                            type="password"
                            className="form-control"
                            id="password2"
                            placeholder="Password"
                            value={password2}
                            onChange={(e) => setPassword2(e.target.value)}
                            required
                        />
                        <label htmlFor="floatingPassword">Ripeti password</label>
                    </div>

                    <button className="btn btn-primary w-100 py-2" type="submit" disabled={isLoading}>
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Registrazione...
                            </>
                        ) : (
                            "Registrati"
                        )}
                    </button>
                    <p className="mt-5 mb-3 text-body-secondary">Sei gia registrato? Clicca  <a href="/login">qui!</a></p>
                    <p className="mt-5 mb-3 text-body-secondary">CiSono© {new Date().getFullYear() }</p>
                </form>
            </main>
            <Footer />
        </div>
    );

};

export default Registration;
